export default "__VITE_ASSET__zykuwI1E__"